// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OptionList-module__root--KpERi {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
}

.OptionList-module__shape-default--T7RZC,
.OptionList-module__shape-normal--UMppJ {
  width: 100%;
}

.OptionList-module__title--MikVM {
  box-sizing: border-box;
  padding: 5px 0 2px;
  color: #1a1a1a;
  font-size: 1.3125rem; /* 21px */
  font-weight: 600;
  line-height: normal;
  overflow-wrap: break-word;
}

.OptionList-module__ui-OptionList-Item--pn2vI {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 34px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 4px 10px 2px;
  border-radius: 4px;
  background-color: #fcfaf7;
  color: #555;
  font-size: 0.875rem; /* 14px */
  font-weight: 600;
  line-height: normal;
  overflow-wrap: break-word;
  cursor: pointer;
}

.OptionList-module__ui-OptionList-Item--pn2vI.OptionList-module__is-active--Z06vH {
  background-color: #1a1a1a;
  color: #fff;
}

.OptionList-module__content--V1D6R {
  display: inline-block;
  font-size: 0.875rem; /* 14px */
  font-weight: 600;
  line-height: normal;
  flex: 1;
}

.OptionList-module__meta--Xvplm {
  display: inline-block;
  color: #999;
  font-size: 0.75rem; /* 12px */
  font-weight: 400;
  line-height: normal;
}

.OptionList-module__ui-OptionList-Item--pn2vI.OptionList-module__is-active--Z06vH .OptionList-module__meta--Xvplm {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/OptionList/OptionList.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;AACX;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".root {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 12px;\n}\n\n.shape-default,\n.shape-normal {\n  width: 100%;\n}\n\n.title {\n  box-sizing: border-box;\n  padding: 5px 0 2px;\n  color: #1a1a1a;\n  font-size: 1.3125rem; /* 21px */\n  font-weight: 600;\n  line-height: normal;\n  overflow-wrap: break-word;\n}\n\n.ui-OptionList-Item {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  height: 34px;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 10px 2px;\n  border-radius: 4px;\n  background-color: #fcfaf7;\n  color: #555;\n  font-size: 0.875rem; /* 14px */\n  font-weight: 600;\n  line-height: normal;\n  overflow-wrap: break-word;\n  cursor: pointer;\n}\n\n.ui-OptionList-Item.is-active {\n  background-color: #1a1a1a;\n  color: #fff;\n}\n\n.content {\n  display: inline-block;\n  font-size: 0.875rem; /* 14px */\n  font-weight: 600;\n  line-height: normal;\n  flex: 1;\n}\n\n.meta {\n  display: inline-block;\n  color: #999;\n  font-size: 0.75rem; /* 12px */\n  font-weight: 400;\n  line-height: normal;\n}\n\n.ui-OptionList-Item.is-active .meta {\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `OptionList-module__root--KpERi`,
	"shape-default": `OptionList-module__shape-default--T7RZC`,
	"shape-normal": `OptionList-module__shape-normal--UMppJ`,
	"title": `OptionList-module__title--MikVM`,
	"ui-OptionList-Item": `OptionList-module__ui-OptionList-Item--pn2vI`,
	"is-active": `OptionList-module__is-active--Z06vH`,
	"content": `OptionList-module__content--V1D6R`,
	"meta": `OptionList-module__meta--Xvplm`
};
export default ___CSS_LOADER_EXPORT___;
